"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitMoneyString = void 0;
var REGEX_SEPARATORS = /[|]+/;
function splitMoneyString(data) {
    return data.split(REGEX_SEPARATORS);
}
exports.splitMoneyString = splitMoneyString;
